<div>
  <nb-card [nbSpinner]="isWaiting" nbSpinnerStatus="success">
    <nb-card-body>
      <nb-alert outline="success" role="alert" *ngIf="shouldShowActivePlanWarning && !isProgramTemplate">
        <div class="row">
          <div class="col-xx-2">
            <nb-toggle></nb-toggle>
          </div>
          <div class="col">
            Setting a plan as "Active" or tapping the "Send Plan" button will
            deliver the plan to the client by Email.<br />It will also show as
            the default plan in the Client's View.
          </div>
        </div>
      </nb-alert>


      <div class="row" *ngIf="!isProgramTemplate">
        <div class="col">
          <div style="display:flex; align-items: center;">
            <nb-toggle  [disabled]="isWaiting" [checked]="isProgramMode"
              (checkedChange)="onProgramModeChanged($event)">
              Program Mode <span *ngIf="!isProgramMode">(Disabled)</span>

            </nb-toggle>
            <ngx-how-to-modal [helpLabel]='"How To Use Calendar & Program Mode."' style="margin-top:-9px;"
              [link]='"https://www.youtube.com/embed/N2C21vHhcHI"'></ngx-how-to-modal>
          </div>

        </div>


      </div>


      <div *ngIf="isProgramMode && plans?.length > 0 && !isProgramTemplate">



        <div class="row">
          <div class="col">

            <div *ngIf="isProgramMode" class="d-flex align-items-center mb-2 program-start-date">
              <label class="mb-0 mr-2 label-text">Program Start Date</label>
              <input nbInput type="text" placeholder="Click here..." [disabled]="isWaiting" [nbDatepicker]="datepicker"
                value="{{ programStartDate | date }}" style="max-width: 150px !important;" />
              <nb-datepicker #datepicker [date]="programStartDate" (dateChange)="onProgramStartDateChanged($event)">
              </nb-datepicker>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="col-sm">
            <div *ngIf="isProgramMode" class="d-flex align-items-center mb-2 program-end-date">
              <label class="mb-0 mr-2 label-text">Program End Date <br> <span style="font-size:xx-small">(Auto
                Calculated)</span></label>
              
              <label class="mb-0 mr-2" style="
              margin-left: 10px;
          ">{{ programEndDate | date }} </label>
            </div>
          </div>



        </div>



        <div class="row">
          <div class="col-sm">
            <div *ngIf="isProgramMode" class="d-flex align-items-center mb-2 program-end-date">
              <label class="mb-0 mr-2 label-text">Client Visibility</label>
              <nb-select style="width: 150px;" [(selected)]="programVisibility"
                (selectedChange)="onProgramViewTypeChange()">
                <nb-option value="0">Show Complete Calendar</nb-option>
                <nb-option value="1">Show Only Current Phase</nb-option>
                <nb-option value="2">Show Next 4 Weeks</nb-option>
                <nb-option value="3">Show Next 8 Weeks</nb-option>
                <nb-option value="4">Show Next 12 Weeks</nb-option>
              </nb-select>
            </div>
          </div>
          <div class="col-sm text-right" *ngIf="isProgramMode">
            <button nbButton  (click)="onProgramToClient()" class="btn-circle btn-xl btn-main mb-2">
              View & Send Program
            </button>
          </div>

        </div>
      </div>


      <div cdkDropList [cdkDropListData]="plans" (cdkDropListDropped)="onPlanDropped($event)">
        <div [cdkDragDisabled]="disableCDK()" cdkDrag [cdkDragStartDelay]="cdkDelay()"
          *ngFor="let plan of plans; trackBy: planTrackBy; let i = index" class="plan-row">
          <div class="custom-placeholder" *cdkDragPlaceholder></div>
          <ngx-plan-list-item [isFitnessPlan]="isFitness" [planIndex]="i" [programTemplateId]="programTemplateData?.id" [patientId]="patient?.id" [patientGuid]="patient?.patientGuid"
            [programMode]="isProgramMode" [isProgramTemplate]="isProgramTemplate" [startDate]="startDate(i)" [endDate]="endDate(i)" [(plan)]="plans[i]"
            (changed)="onChanged($event, i)" (activeChanged)="onActiveChanged($event)" (duplicated)="onDuplicated($event)"
            (deleted)="onDeleted($event, i)" (moved)="onMoved($event, i)">
          </ngx-plan-list-item>
        </div>
      </div>
    </nb-card-body>

    <nb-card-footer *ngIf="_isFitness">
      <div class="actions">
        <ng-template #customNewTutorialContent>
          You can create Meal or Exercise plans, in this example, let’s create a
          Workout Plan. Tap the Add New Plan button.
        </ng-template>

        <ng-template #customDoneTutorialButton></ng-template>

        <div [class.in-tutorial]="joyrideService.isTourInProgress()" title="Creating New Plans"
          [joyrideStep]="TutorialIDs.AddNewPlan" stepPosition="left" [nextTemplate]="customDoneTutorialButton"
          [doneTemplate]="customDoneTutorialButton" [stepContent]="customNewTutorialContent">
          <button i18n="@@AddNewPlan" nbButton  class="btn-circle btn-xl btn-main" [disabled]="isWaiting" type="submit"
            (click)="onAddPlan()">
            Add New Plan
          </button>
        </div>
      </div>
    </nb-card-footer>



    <nb-card-footer *ngIf="!_isFitness">
      <div class="actions">


        <button i18n="@@AddNewPlan" nbButton  class="btn-circle btn-xl btn-main" [disabled]="isWaiting" type="submit"
          (click)="onAddPlan()">
          Add New Plan
        </button>

      </div>
    </nb-card-footer>



  </nb-card>
</div>